import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { fetchTerminals } from '../../store/actions/checkout.actions';

import DropdownContainer from '../global/fields/Dropdown';
import FormsyCheckbox from '../global/fields/Checkbox';
import {
  getSalesChannelOptions,
  getSubmitPending,
} from '../../store/selectors/checkout.selectors';

import { checkout as checkoutGlobalAPI } from '../../mock/globalAPI';

export class TerminalSelect extends Component {
  componentDidMount() {
    this.props.fetchTerminalsAction();
  }

  render() {
    const {
      salesChannelOptions,
      isSubmitPending,
      salesChannel,
      paymentMethod,
    } = this.props;
    const currentSalesChannel = salesChannelOptions && salesChannelOptions.find(({ label }) => label === salesChannel);
    return (
      <div className="checkout-dropdowns__wrapper form-fancy">
        <h2 className="checkout__subheader h3">{checkoutGlobalAPI.step2}</h2>
        <div className="form-fancy-wrapper sales-channel">
          <DropdownContainer
            name="salesChannel"
            label={checkoutGlobalAPI.dropdownLabels.salesChannel}
            ariaLabel="Sales Channel Select"
            className="dropdown-container__selection"
            validations="isExisty"
            validationError="Sales channel required"
            required
            options={salesChannelOptions}
            disabled={isSubmitPending}
          />
        </div>
        {currentSalesChannel && (
          <div className="form-fancy-wrapper sales-channel">
            <DropdownContainer
              name="paymentMethod"
              label={checkoutGlobalAPI.dropdownLabels.paymentMethod}
              className="dropdown-container__selection"
              validations="isExisty"
              validationError="Payment method required"
              required
              options={currentSalesChannel.paymentMethods.map((method) => ({ value: method, label: method }))}
              disabled={isSubmitPending}
            />
          </div>
        )}
        {paymentMethod === 'POSTerminal' && (
          <>
            <h2 className="checkout__subheader h3">{checkoutGlobalAPI.step3}</h2>
            <div className="form-fancy-wrapper terminal">
              <DropdownContainer
                name="terminal"
                label={checkoutGlobalAPI.dropdownLabels.terminal}
                ariaLabel="Terminal Select"
                className="dropdown-container__selection"
                validations="isExisty"
                validationError="Terminal selection required"
                required
                options={currentSalesChannel.paymentTerminals.map(({ terminalId }) => ({ value: terminalId, label: terminalId }))}
                disabled={isSubmitPending}
              />
            </div>
          </>
        )}
        {paymentMethod === 'PayByLink' && (
          <FormsyCheckbox
            name="sendPayLink"
            label={checkoutGlobalAPI.sendPayLink}
            value={true}
          />
        )}
      </div>
    );
  }
}

export const mapStateToProps = (state) => ({
  salesChannelOptions: getSalesChannelOptions(state),
  isSubmitPending: getSubmitPending(state),
});

const mapDispatchToProps = {
  fetchTerminalsAction: fetchTerminals,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
)(TerminalSelect);
